

export function Dashboard() {


  return (
    <div className='p-4 d-flex justify-content-start align-content-center flex-wrap '>
      <h1>DashBoard</h1>
    </div>
  );
}
